export default "__VITE_ASSET__C9Y_WbY$__"